<template>
  <div class="settings-content settings-content-billing">
    <div
      ref="settings_section"
      class="settings-section"
    >
      <div class="main-title">
        {{ locales('settings_billing_title') }}
      </div>
      <div class="row-info current-plan">
        <div class="info-label">
          {{ locales('billing_current_plan_label') }}
        </div>
        <div class="description name">
          <p class="details details">
            {{ currentPlanName }}
          </p>
        </div>
      </div>
      <div class="row-info plan">
        <div class="info-label">
          {{ locales('billing_upgrade_label') }}
        </div>
        <div class="description">
          <p
            class="details details-text"
            v-html="planLabel"
          />
          <p
            v-if="!isOverSubscription"
            class="details details-bold"
          >
            {{ planPeriod.dateTo }}
          </p>
          <global-button
            :config="{
              isGlobal: true,
              locale: locales(`${isTrial || isOverSubscription ? 'upgrade_plan_btn' : 'billing_upgrade_btn_text'}`),
              handler: onUpgradePlanClick,
              size: 'small',
              color: 'light-orange',
              isDisable: false
            }"
          />
        </div>
      </div>
      <div
        v-if="!isTrial"
        class="row-info editors"
      >
        <div class="info-label">
          {{ locales('billing_editors_label') }}
        </div>
        <div class="description">
          <p class="details details-text">
            {{ locales('billing_editors_text') }}
          </p>
          <p class="details details-bold">
            {{ userCount }}
          </p>
          <div
            v-if="isSubscriptionActive"
            :class="['string-btn', '']"
            @click="onChangeTeamSizeClick"
          >
            {{ locales('billing_change_team_size_btn') }}
          </div>
        </div>
      </div>
      <div
        v-if="!isTrial"
        class="row-info payment-method"
      >
        <div class="info-label">
          {{ locales('billing_payment_method_label') }}
        </div>
        <div class="description">
          <p class="details details-text">
            {{ locales('billing_payment_method_text') }}
          </p>
          <div
            :class="['string-btn','']"
            @click="changePaymentMethod"
          >
            {{ locales('billing_payment_method_btn') }}
          </div>
        </div>
      </div>
    </div>
    <delimiter v-if="paymentHistory.length" />
    <div
      v-if="paymentHistory.length"
      class="settings-section invoices"
    >
      <div class="main-title">
        {{ locales('settings_billing_invoices_title') }}
      </div>
      <div
        :class="['invoices-table', 'show-all']"
      >
        <div class="table-row table-row_head">
          <div class="table-cell table-cell_date">
            {{ locales('date_key') }}
          </div>
          <div class="table-cell table-cell_desc">
            {{ locales('desc_key') }}
          </div>
          <div class="table-cell table-cell_editors">
            {{ locales('editors_key') }}
          </div>
          <div class="table-cell table-cell_total">
            {{ locales('total_key') }}
          </div>
          <div class="table-cell table-cell_status">
            {{ locales('status_key') }}
          </div>
        </div>
        <div
          v-for="(item, index) in paymentHistory"
          :key="index"
          class="table-row"
        >
          <div class="table-cell table-cell_date">
            {{ item.date }}
          </div>
          <div
            class="table-cell table-cell_desc"
            :title="item.orderName"
          >
            {{ item.orderName }}
          </div>
          <div class="table-cell table-cell_editors">
            <span
              v-if="item.users"
              class="editors-count"
            >
              {{ item.users }}
            </span>
            <div
              v-else
              class="editors-no-data"
            >
              <span class="line" />
            </div>
          </div>
          <div class="table-cell table-cell_total">
            {{ `$ ${item.order_total}` }}
          </div>
          <div
            :class="['table-cell table-cell_status']"
            :style="{ color: getStatusColor(item.action) }"
            :title="item.actionName"
          >
            {{ item.actionName }}
          </div>
          <div
            v-if="item.invoiceLink"
            class="table-cell table-cell_invoice-link"
          >
            <a
              :href="item.invoiceLink"
              target="_blank"
            >{{ locales('view_invoice_link') }}</a>
          </div>
        </div>
      </div>
    </div>

    <delimiter
      v-if="isSubscriptionActive"
      :style="{position: 'fixed', bottom: '108px', width: '100%', left: 0}"
    />
    <div
      v-if="isSubscriptionActive"
      ref="billing_footer"
      class="billing-footer"
    >
      <vgp-button
        type="destructive-border"
        :label="locales('cancel_btn')"
        :small="true"
        @onClick="unsubscribeClick"
      />
      <!-- <div
        class="footer-btn footer-btn--cancel"
        @click="unsubscribeClick"
      >
        {{ locales('cancel_btn') }}
      </div> -->
    </div>
  </div>
</template>

<script>
import feedbackHelper from '../../../helpers/feedback';
import dateHelper from '../../../helpers/dateFormats';
import plansModel from '../../../models/plans';
import constants from '../../../admin/helpers/constants';

import globalButton from '../../common/VueComponents/globalButton/globalButton.vue';
import Delimiter from '../include/delimiter.vue';
import app from '../../../app';
import vgpButton from '../../common/VueComponents/globalButton/vgpButton.vue';

export default {
  components: {
    globalButton,
    Delimiter,
    vgpButton,
  },
  data() {
    return {
      locales: __,
      provider: '',
      realUserCount: '',
      userPlan: {},
    };
  },
  computed: {
    isTrial() {
      return plansModel.isTrial();
    },
    isOverSubscription() {
      return plansModel.isOverSubscription();
    },
    isSubscriptionActive() {
      return plansModel.isActive() && plansModel.isCanCancelSubscription() && !plansModel.isTrial();
    },
    planLabel() {
      const isTerminated = plansModel.isTerminated() || plansModel.isRefunded();
      const isFinishedSubscription = plansModel.isFinished();
      const isAnnual = plansModel.isAnnual();

      if (isTerminated || isFinishedSubscription || plansModel.isOverSubscription()) {
        // label = __(`${this.userPlan.name}_plan_expired`);

        return __('billing_page_plan_expired', { planName: this.currentPlanName });
      }

      if (this.isTrial) {
        return __('trial_billing_plan_annual_label');
      }

      // if (isAnnual) {
      //   label = __(`${isTrial ? 'trial' : this.userPlan.name}_billing_plan_annual_label`);
      // } else {
      //   label = __(`${isTrial ? 'trial' : this.userPlan.name}_billing_plan_month_label`);
      // }

      return isAnnual
        ? __('billing_page_subscription_annual_paid_text_by_plan_name', { planName: this.currentPlanName })
        : __('billing_page_subscription_month_paid_text_by_plan_name', { planName: this.currentPlanName });
    },
    currentPlanName() {
      if (this.isTrial) {
        return __('billing_trial_description');
      }

      const planName = plansModel.getPlanName();
      const planLocale = plansModel.getPlanTitleLocale();

      if (['base', 'pro'].includes(planName)) {
        return __(`${planLocale}_plan_locale`);
      }

      return planName[0].toUpperCase() + planName.slice(1);
    },
    paymentHistory() {
      return this.$store.getters['paymentClient/paymentHistory'];
    },
    planPeriod() {
      const period = this.$store.getters['paymentClient/currentSubscriptionPeriod'];
      const planPeriod = {
        dateTo: dateHelper.formatDateNoTime(period.dateTo),
        dateFrom: dateHelper.formatDateNoTime(period.dateFrom),
      };

      return planPeriod;
    },
  },
  mounted() {
    // using for annual offer email
    if (this.$route.query.annual_offer === '1') {
      this.$store.commit('paymentClient/showUpgradePopup', {
        show: true,
        mode: 'change-plan',
        newPlan: this.userPlan,
        isAnnual: 1,
      });

      userExtAnalytics.log('annual_offer_upgrade_popup_open', { plan: this.userPlan });
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      userExtAnalytics.log('billing_opened');
      const userPlanId = plansModel.getPlanId();

      this.provider = plansModel.getSubscriptionProvider();
      this.userCount = plansModel.getUserCount() || 1;

      if (!plansModel.isTrial()) {
        this.userPlan = user.paymentPlans.find(plan => plan.id === userPlanId);
      }
      this.$store.dispatch('paymentClient/fetchCurrentSubscriptionPeriod');
      this.$store.dispatch('paymentClient/fetchPaymentHistory');
    },
    getStatusColor(status) {
      return constants.PAYMENT_TYPE_COLORS[status] || '#000000'; // Default to black if no color is found
    },
    async onChangeTeamSizeClick() {
      if (plansModel.isCanNotBeUpdatedWithoutSales()) {
        app.trigger('messageUsForm:show', 'upgrade-via-sale-contact-us-form');

        return false;
      }

      if (plansModel.isRequireNewSubscriptionInsteadOfUpdate()) {
        this.$store.commit('paymentClient/showPaymentPage', true);

        return;
      }

      this.$store.commit('paymentClient/showUpgradePopup', {
        show: true,
        mode: 'change-team-size',
        newPlan: this.userPlan,
      });
    },

    async changePaymentMethod() {
      if (plansModel.isOrderProcessing()) {
        webix.message({ type: 'info', text: __('order_processing_message_for_upgrade') });

        return false;
      }

      userExtAnalytics.log('billing_page_payment_method_change_clicked');

      await plansModel.sendLoginEmailForChangePaymentMethod();
      await this.$store.dispatch('globalPopup/show', {
        type: 'paymentConfirm',
        ok: __('common_ok'),
        message: `${__('comfirm_popup_change_payment_message')}: <a href="mailto:${user.accountPlanData.provider_payment_email}">${user.accountPlanData.provider_payment_email}</a>`,
        footerText: __('comfirm_popup_change_payment_footer'),
        width: 515,
      });
    },
    async onUpgradePlanClick() {
      if (plansModel.isCanNotBeUpdatedWithoutSales()) {
        app.trigger('messageUsForm:show', 'upgrade-via-sale-contact-us-form');

        return false;
      }

      if (plansModel.isRequireNewSubscriptionInsteadOfUpdate()) {
        this.$store.commit('paymentClient/showPaymentPage', true);

        return false;
      }
      // if (plansModel.isTrial() || isTerminated || isRefunded || isFinished) {
      //   this.$store.commit('paymentClient/showPaymentPage', true);

      //   return;
      // }

      this.$store.dispatch('globalPopup/show', {
        type: 'paymentPopup',
      });
    },
    unsubscribeClick() {
      userExtAnalytics.log('billing_page_subscription_cancel_clicked');
      $$('userAccountSubscribe').show();
    },
    // #paymentDataPlan we don't use this method. we should remove it and dispatch method
    restoreClick() {
      this.$store.dispatch('paymentClient/restoreSubscription');
    },
    sendEmail() {
      feedbackHelper.send({
        type: 'billing-upgrade',
        send_followup_email: false,
      });
    },
  },
};
</script>

<style scoped src='../less/profileSettings.less'></style>
